/* Sentry 2026-09-11 (DE-1W4/1W7): gesperrter Browser-Speicher (Safari "Alle Cookies blockieren") wirft bei jedem
   Zugriff SecurityError, schon auf window.localStorage selbst - deshalb loest der Helfer den Speicher erst im try auf
   und liefert null; Loeschen laeuft in try/catch. */
function dnSpeicherLesen(name, schluessel) { try { return window[name].getItem(schluessel); } catch (dnFehler) { return null; } }
document.addEventListener('DOMContentLoaded', function() {
  let storedValue = dnSpeicherLesen('localStorage', 'dataChildCollectionNew');
  
  function handleButtonClick(event) {
    var clickedElement = event.currentTarget;
    if (!clickedElement) return;

    var parentElement = clickedElement.closest('.buttn_list');
    if (!parentElement) return;

    var dataChildCollectionNew = parentElement.getAttribute('data-parent_child');
    if (!dataChildCollectionNew) return;

    var storedValue = dnSpeicherLesen('localStorage', 'dataChildCollectionNew');

    if (storedValue && storedValue !== dataChildCollectionNew) {
      localStorage.removeItem('dataChildCollectionNew');
    }

    localStorage.setItem('dataChildCollectionNew', dataChildCollectionNew);
  }

  document.querySelectorAll('.buttn_list a').forEach(function(element) {
    element.addEventListener('click', handleButtonClick);
  });

  document.querySelectorAll('.top_collection_main a').forEach(function(element) {
    element.addEventListener('click', function(event) {
      localStorage.removeItem('dataChildCollectionNew');
    });
  });

  document.querySelectorAll('.iwp-main_btn a').forEach(function(element) {
    element.addEventListener('click', function(event) {
      const dataCollection = element.getAttribute('data-parent_child');
      if (dataCollection) {
        localStorage.setItem('dataChildCollectionNew', dataCollection);
      } else {
        localStorage.removeItem('dataChildCollectionNew');
      }
    });
  });

  if (storedValue) {
    var matchingElement = document.querySelector('.buttn_list[data-parent_child="' + storedValue + '"]');
    if (matchingElement) {
      document.querySelectorAll('.buttn_list').forEach(function(buttn_list) {
        buttn_list.classList.remove('active_btn');
      });
      matchingElement.classList.add('active_btn');
    }
    if (matchingElement && matchingElement.closest('.collection_tabs_buttn')) {
      var parentElement = matchingElement.closest('.collection_tabs_buttn');
      document.querySelectorAll('.collection_tabs_buttn').forEach(function(tabs_buttn) {
        tabs_buttn.classList.remove('active');
      });
      parentElement.classList.add('active');
    }
    const storedValueParts = storedValue.split('_');
    const storedValueAfterUnderscore = storedValueParts[0];
    const matchingCollectionLists = document.querySelectorAll('.collection_top_item');
    if (storedValueAfterUnderscore && matchingCollectionLists.length > 0) {
      matchingCollectionLists.forEach(function(matchingCollectionList) {
        if (matchingCollectionList.getAttribute('data-parent') == storedValueAfterUnderscore) {
          matchingCollectionList.classList.add('active');
        } else {
          matchingCollectionList.classList.remove('active');
        }
      });
    }
  }
});

$(document).ready(function(){

  $('#show_first_img').click(function() {
      $('.tile-media_img_1').css('display', 'block');
      $('.tile-media_img_2').css('display', 'none');
  });

  $('#show_second_img').click(function() {
      $('.tile-media_img_1').css('display', 'none');
      $('.tile-media_img_2').css('display', 'block');
  });
  
  $('.drawer_cart_icon').on('click',function(){
    $('mobile-navigation').attr('open',false)
  })

  $('.drawer_search_icon').on('click',function(){
    $('predictive-search-drawer .new_menu_back').addClass('active')
    $('mobile-navigation').attr('open',false)
    $('predictive-search-drawer').attr('open',true)
  })

  $('predictive-search-drawer .new_menu_back').on('click',function(){
    
    $('mobile-navigation').attr('open',true)
    $('predictive-search-drawer').attr('open',false)
    $('predictive-search-drawer .new_menu_back').removeClass('active')
  })

  $('.search_drawer_search_icon,.search_drawer_cart_icon').on('click',function(){
    $('predictive-search-drawer').attr('open',false)
  })

  $('.drawer__close-button,store-header .header__icon-wrapper[href="/search"]').on('click',function(){
    $('predictive-search-drawer .new_menu_back').removeClass('active')
  })


  // $('button[aria-controls="mobile-menu-drawer"]').on('click',function(){
  //   if( $('#mobile-menu-drawer').attr('open') == undefined ){
  //     $('mobile-navigation').attr('open',true)
  //   }
  // })



  // collection page js
 $('body').on('change','#image_toggle',function(){
        let $primaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__primary-image'); 
        let $secondaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__secondary-image'); 
        console.log("click test");
        if (this.checked) {
            // Show second image
            // $('#show_first_img').removeClass('active');
            // $('#show_second_img').addClass('active');
            $primaryImage.attr('style', 'visibility:hidden;opacity:0;');
            $secondaryImage.attr('style', 'visibility:visible;opacity:1;display:block');
        } else {
            // Show first image
            // $('#show_second_img').removeClass('active');
            // $('#show_first_img').addClass('active');
            $primaryImage.attr('style', 'visibility:visible; opacity:1;');
            $secondaryImage.attr('style', 'visibility:hidden;opacity:0;display:none');
        }
    });

  
 // collection img click change second image
  $('body').on('click','#show_first_img_col',function(){
    $(this).addClass('active') ;
    $("#show_second_img_col").removeClass("active");
    let $primaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__0primary-image'); 
    let $secondaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__secondary-image0'); 
    $primaryImage.attr('style', 'visibility:visible; opacity:1;');
    $secondaryImage.attr('style', 'visibility:hidden;opacity:0;display:none');
  })

  $('body').on('click','#show_second_img_col',function(){
    $(this).addClass('active') ;
    $("#show_first_img_col").removeClass("active");
    let $primaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__0primary-image'); 
    let $secondaryImage = $('.product-item .product-item__image-wrapper > a').find('.product-item__secondary-image0'); 
    
    if ($secondaryImage.length > 0) { 
        $primaryImage.attr('style', 'visibility:hidden;opacity:0;');
        $secondaryImage.attr('style', 'visibility:visible;opacity:1;display:block');
    }
    
  })

// new collection img click change second image
 




  
  
  $('body').on('click','.js-load-more', function(){
   let $this =$(this),
   totalPages = parseInt($('[data-all-pages]').val()),
   currentPage = parseInt($('[data-this-page]').val()),
   datacollurl = $('[data-coll-url]').val();
    
   $this.attr('disabled', true);
   $this.find('[load-more-text]').addClass('hide');
   $this.find('[loader]').removeClass('hide');

    
   let nextUrl = $('[data-next-link]').val();
   let current_page_new = currentPage + 1;
   let next_coll = currentPage + 2;
    
   $.ajax({
     url: nextUrl,
     type: 'GET',
     dataType: 'html',
     success: function(responseHTML){
       if(datacollurl.includes('?')){
         $('[data-next-link]').val(datacollurl + "&page="+next_coll);
       }else{
         $('[data-next-link]').val(datacollurl + "?page="+next_coll);
       }
       $('[data-this-page]').val(current_page_new);
       
       $('product-list .product-list__inner').append($(responseHTML).find('product-list .product-list__inner').html());
       
       
     },
     complete: function() {
       if(current_page_new < totalPages) {
         $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } 
       
       if(current_page_new >= totalPages) {
           var queryString = nextUrl.split('?')[1];
            var params = new URLSearchParams(queryString);
            params.delete('page');
            params.delete('view');
            var newQueryString = '&' + params.toString();
            var apiTemplate = 'sold-out-filter-api';
             if ($('body').hasClass('collection-2025')) {
                apiTemplate = 'sold-out-filter-api-2025';
             }
             /* Neue Kategorievorlage collection-us-design (2026-09-09, wie US; auch als ?view=-Vorschau):
                eigene Nachlade-View, damit die ausverkauften Produkte dieselbe Karte bekommen
                (templates/collection.sold-out-filter-api-dn.liquid). */
             if ($('body').hasClass('template_suffix_collection-us-design') || $('[data-dn-soldout-view]').length) {
                apiTemplate = 'sold-out-filter-api-dn';
             }
            $.ajax({
               url: `${datacollurl}?view=${apiTemplate}${newQueryString}`,
               type: 'GET',
               dataType: 'html',
               success: function(responseHTML){
                 $('product-list .product-list__inner').append($(responseHTML).find('product-list .product-list__inner').html());
               }
             })
         $this.find('[load-more-text]').text('Alle Produkte geladen').removeClass('hide'); $this.find('[loader]').addClass('hide');
       } 
       
      setTimeout(() => {
       $('product-list .product-list__inner').find('product-item').each(function(){
         let reviewCount = $(this).find('.jdgm-prev-badge').attr('data-number-of-reviews');
         if (reviewCount) {
           $(this).find('.jdgm-prev-badge .jdgm-prev-badge__text').text(`(${reviewCount})`);
           $(this).find('.jdgm-prev-badge .jdgm-prev-badge__text').show();
         }
       })
      }, 1000);
       
     }
     
   })
  }); 

if (window.location.href.includes("/collections/")) {
  /* Nur mit Produktliste und Sammlungs-Adresse (2026-09-27): die Drops-Vorlage hat beides nicht, ohne Schutz
     ging ein Abruf an /collections/undefined?view=sold-out-filter-api (404) auf jeder Drops-Seite. */
  if (!$('.js-load-more').length > 0 && $('product-list .product-list__inner').length && ($('[data-coll-url]').val() || window.location.search)) {
    let datacollurlNew = $('[data-coll-url]').val();
    let currentURL = window.location.href;
     var apiTemplate = 'sold-out-filter-api';
     if ($('body').hasClass('collection-2025')) {
        apiTemplate = 'sold-out-filter-api-2025';
     }
     /* Neue Kategorievorlage collection-us-design (2026-09-09, wie US; auch als ?view=-Vorschau):
        eigene Nachlade-View, damit die ausverkauften Produkte dieselbe Karte bekommen
        (templates/collection.sold-out-filter-api-dn.liquid). */
     if ($('body').hasClass('template_suffix_collection-us-design') || $('[data-dn-soldout-view]').length) {
        apiTemplate = 'sold-out-filter-api-dn';
     }
      
      let ajaxURL = `${datacollurlNew}?view=${apiTemplate}`;
      if (currentURL.includes('?')) {
        /* view als Parameter setzen statt anhaengen: eine Vorschau traegt schon
           ?view=collection-us-design, zwei view-Parameter waeren mehrdeutig. */
        var dnUrl = new URL(currentURL);
        dnUrl.searchParams.set('view', apiTemplate);
        ajaxURL = dnUrl.toString();
      }
    
    $.ajax({
       url: ajaxURL,
       type: 'GET',
       dataType: 'html',
       success: function(responseHTML){
         $('product-list .product-list__inner').append($(responseHTML).find('product-list .product-list__inner').html());
          setTimeout(() => {
           $('product-list .product-list__inner').find('product-item').each(function(){
             let reviewCount = $(this).find('.jdgm-prev-badge').attr('data-number-of-reviews');
             if (reviewCount) {
               $(this).find('.jdgm-prev-badge .jdgm-prev-badge__text').text(`(${reviewCount})`);
               $(this).find('.jdgm-prev-badge .jdgm-prev-badge__text').show();
             }
           })
          }, 1000);
       }
     })
    
  }

  setTimeout(() => {
       $('product-list .product-list__inner').find('product-item').each(function(){
         let reviewCount = $(this).find('.jdgm-prev-badge').attr('data-number-of-reviews');
         if (reviewCount) {
           $(this).find('.jdgm-prev-badge .jdgm-prev-badge__text').text(`(${reviewCount})`);
           $(this).find('.jdgm-prev-badge .jdgm-prev-badge__text').show();
         }
       })
      }, 1000);
  
} 
  // nav bar open/close on click - Mobile menu
  // $('body').on('click','.mobile-nav__link',function(){
  //   let navItemclicked = $(this).attr('aria-controls');
  //   $('.mobile-nav__link').each(function(){
  //     let navItem = $(this).attr('aria-controls');
  //     if (navItemclicked != navItem) {
  //       $(this).attr('aria-expanded', false);
  //       $(this).siblings('collapsible-content').css("overflow", "hidden");
  //       $(this).siblings('collapsible-content').removeAttr("open");
  //     }
  //   })
  // })



$('body').on('click', '.cart_title_remove_icon', function () {
  const parent = $(this).closest('line-item.line-item');
  const anchor = parent.find('.line-item__remove-button');
  
  if (anchor.length) {
    anchor[0].click(); // Use native DOM click method
  } else {
    console.warn('Anchor tag not found!');
  }
});
  
$('body').on('click', '.line-itemprop_edit .edit_set', function () {
  const parent = $(this).closest('line-item.line-item');
  const anchor = parent.find('.line-item__content-wrapper .line-item__image-wrapper');
  
  if (anchor.length) {
    anchor[0].click(); // Use native DOM click method
  } else {
    console.warn('Anchor tag not found!');
  }
});


  $('body').on('click','men-item .back_menu', function(){
    const mobileNavItem = $(this).closest(".mobile-nav__item");
      if (mobileNavItem) {
        const toggleButton = mobileNavItem.find('button[aria-expanded="true"]');
        if (toggleButton) {
            toggleButton.click();
        }
    }
  })
  
  // new home tab section
  $('.new_tab_single').on('click',function(){
      $('.new_tab_single').removeClass('active')
      $(this).addClass('active')

      $('.new_tabs_content').hide()
      $(`.new_tabs_content[data-id=${$(this).attr('id')}]`).show();
    })

// Define the global removeSet function attached to the window object
window.removeSet = function(event) {
    event.preventDefault();
    const clickedButton = event.currentTarget;

    let setIDParent = clickedButton.getAttribute('data-set-id');

    let lineItemLoader = $(`line-item[data-parent-set="${setIDParent}"]`).find('.line-item__loader');
    lineItemLoader.removeAttr('hidden');
    lineItemLoader.find('.line-item__loader-spinner').removeAttr('hidden');
    let lineItemLoaderSet = $(`line-item[data-set="${setIDParent}"]`).find('.line-item__loader');
    lineItemLoaderSet.removeAttr('hidden');
    lineItemLoaderSet.find('.line-item__loader-spinner').removeAttr('hidden');

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            let itemsToRemove = [];

            cart.items.forEach(item => {
                for (let propertyName in item.properties) {
                    if (item.properties.hasOwnProperty(propertyName) && propertyName === '_set_id' && item.properties[propertyName] === setIDParent) {
                        itemsToRemove.push({
                            id: item.key,
                            quantity: 0
                        });
                    }
                }
            });

            if (itemsToRemove.length > 0) {
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        updates: itemsToRemove.reduce((acc, item) => {
                            acc[item.id] = item.quantity;
                            return acc;
                        }, {})
                    })
                })
                .then(response => response.json())
                .then(() => {
                    document.querySelector(`.line-item__remove-button[data-set-id="${setIDParent}"]`).click();
                })
                .catch(error => console.error('Error:', error));
            } else {
              document.querySelector(`.line-item__remove-button[data-set-id="${setIDParent}"]`).click();
            }
        })
        .catch(error => console.error('Error:', error));
}



    $('body').on('mouseenter', 'color-choose-drawer .product__media-list', function () {
      if ($(this).closest('.popup_color_slider_inner').length > 0) {
        return;
      }
        const $parent = $(this);
        if ($parent.length) {
            const $pageDots = $parent.find('.flickity-page-dots');
            if ($pageDots.length) {
                const $secondDot = $pageDots.find('li:nth-child(2)');
                if ($secondDot.length) {
                    $secondDot.trigger('click');
                }
            }
        }
    });

$('body').on('mouseleave', 'color-choose-drawer .product__media-list', function () {
    if ($(this).closest('.popup_color_slider_inner').length > 0) {
      return;
    }
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            // Check hover state using DOM API
            if ($pageDots[0] && $pageDots[0].matches(':hover')) {
                return;
            }

            const $firstDot = $pageDots.find('li:nth-child(1)');
            if ($firstDot.length) {
                $firstDot.trigger('click');
            }
        }
    }
});


$('body').on('mouseenter', 'color-choose-drawer .color__media-list', function () {
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            const $secondDot = $pageDots.find('.flickity-page-dot:nth-child(2)');
            if ($secondDot.length) {
                $secondDot.trigger('click');
            }
            const $secondDotList = $pageDots.find('li:nth-child(2)');
            if ($secondDotList.length) {
                $secondDotList.trigger('click');
            }
        }
    }
});

$('body').on('mouseleave', 'color-choose-drawer .color__media-list', function () {
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            // Check hover state using DOM API
            if ($pageDots[0] && $pageDots[0].matches(':hover')) {
                return;
            }

            const $firstDot = $pageDots.find('.flickity-page-dot:nth-child(1)');
            if ($firstDot.length) {
                $firstDot.trigger('click');
            }
            const $firstDotList = $pageDots.find('li:nth-child(1)');
            if ($firstDotList.length) {
                $firstDotList.trigger('click');
            }
        }
    }
});


 $('body').on('mouseenter', '.flickity__media-list', function () {
  if ($(this).closest('.popup_color_slider_inner').length > 0) {
        return;
    }
        const $parent = $(this);
        if ($parent.length) {
            const $pageDots = $parent.find('.flickity-page-dots');
            if ($pageDots.length) {
                const $secondDot = $pageDots.find('.flickity-page-dot:nth-child(2)');
                const $secondDotNew = $pageDots.find('.dot:nth-child(2)');
                if ($secondDot.length) {
                    $secondDot.trigger('click');
                }
                if ($secondDotNew.length) {
                    $secondDotNew.trigger('click');
                }
            }
        }
    });

$('body').on('mouseleave', '.flickity__media-list', function () {
  if ($(this).closest('.popup_color_slider_inner').length > 0) {
  console.log($(this).closest('.popup_color_slider_inner'));
        return;
    }
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            // Check hover state using DOM API
            if ($pageDots[0] && $pageDots[0].matches(':hover')) {
                return;
            }

            const $firstDot = $pageDots.find('.flickity-page-dot:nth-child(1)');
            const $firstDotNew = $pageDots.find('.dot:nth-child(1)');
            if ($firstDot.length) {
                $firstDot.trigger('click');
            }
            if ($firstDotNew.length) {
                $firstDotNew.trigger('click');
            }
        }
    }
});
  
  // collection 2025
    $('body').on('mouseenter', '.product__media-list', function () {
      if ($(this).closest('.popup_color_slider_inner').length > 0) {
        return;
    }
    
    if (document.body.classList.contains('show-second-image-active')) {
        return;
    }
        const $parent = $(this);
        if ($parent.length) {
            const $pageDots = $parent.find('.flickity-page-dots');
            if ($pageDots.length) {
                const $secondDot = $pageDots.find('li:nth-child(2)');
                if ($secondDot.length) {
                    $secondDot.trigger('click');
                }
            }
        }
    });

$('body').on('mouseleave', '.product__media-list', function () {
  if ($(this).closest('.popup_color_slider_inner').length > 0) {
        return;
    }

    if (document.body.classList.contains('show-second-image-active')) {
        return;
    }
    const $parent = $(this);
    if ($parent.length) {
        const $pageDots = $parent.find('.flickity-page-dots');
        if ($pageDots.length) {
            // Check hover state using DOM API
            if ($pageDots[0] && $pageDots[0].matches(':hover')) {
                return;
            }

            const $firstDot = $pageDots.find('li:nth-child(1)');
            if ($firstDot.length) {
                $firstDot.trigger('click');
            }
        }
    }
});

// collection 2025
//     $('body').on('mouseenter', '.main_media_silder .product__media-list', function () {
//         const $parent = $(this);
//         if ($parent.length) {
//             const $pageDots = $parent.find('.flickity-page-dots');
//             if ($pageDots.length) {
//                 const $secondDot = $pageDots.find('li:nth-child(2)');
//                 if ($secondDot.length) {
//                     $secondDot.trigger('click');
//                 }
//             }
//         }
//     });

// $('body').on('mouseleave', '.main_media_silder .product__media-list', function () {
//     const $parent = $(this);
//     if ($parent.length) {
//         const $pageDots = $parent.find('.flickity-page-dots');
//         if ($pageDots.length) {
//             // Check hover state using DOM API
//             if ($pageDots[0] && $pageDots[0].matches(':hover')) {
//                 return;
//             }

//             const $firstDot = $pageDots.find('li:nth-child(1)');
//             if ($firstDot.length) {
//                 $firstDot.trigger('click');
//             }
//         }
//     }
// });

$('body').on('click', '.filter_farbe_image .farbe_image', function(){
  const dataName = $(this).attr('data-name');
  const dataVal = $(this).attr('data-value');
  if ($(this).hasClass('active_color')) {
    $(this).removeClass('active_color');
  } else {
    $(this).addClass('active_color');
  }
  $('form#facet-filters-form').find(`input[name="${dataName}"]`).each(function(){
    if ($(this).val() == dataVal) {
      $(this).click();
    }
  })
})

$('body').on('click', '.other_filters .facetfilter_btn', function(){
  const dataControl = $(this).attr('data-aria-controls');
  $('button.product-facet__meta_filter').click();
  $(`.product-facet__filter-item .collapsible-toggle[aria-expanded="true"]`).each(function(){
    $(this).attr('aria-expanded', 'false');
  });
  $(`.product-facet__filter-item .collapsible-toggle[aria-controls="${dataControl}"]`).click();
}) 



// color chooser zoom popup
$('body').on('click', '.color_zoom_popup', function(){
    const colorHandle = $(this).attr("data-handle");
    const colorTemp = $(this).attr("data-template");
    $(".popup_color_slider_section .color_slider_content_inner").html('<span class="loader-button__loader"> <div class="spinner"> <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"> <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle> </svg> </div> </span>');
    $(".popup_color_slider_section").addClass("active");

    let ajaxURL = `/products/${colorHandle}?section_id=popup-inner-images`;
    if (colorTemp) {
      ajaxURL = `/products/${colorHandle}?view=${colorTemp}&section_id=popup-inner-images`;
    };

    fetch(ajaxURL).then( res => res.text() ).then( data => {
      const html = document.createElement("div");
      html.innerHTML = data;
      const quelle = html.querySelector(".popup_color_slider_section .color_slider_content_inner");
      const ziel = document.querySelector(".popup_color_slider_section .color_slider_content_inner");
      if (!quelle || !ziel) return; // Popup nicht (mehr) da oder Antwort ohne Slider (Sentry NL-6/3D/3C)
      ziel.innerHTML = quelle.innerHTML;
      $(".popup_color_slider_section").addClass("active");
    }) 

}); 

// shape guide
    $('body').on('click', '.size_shape_guide_text', function(){
        $(".popup_shapeguide_section").addClass("active");
    });
    $(".close--icon-popup, .shapeguide_heading, .drawer__overlay").click(function () {
        $(".popup_shapeguide_section").removeClass("active");
    });
// shape guide end

// Size guide

    $('body').on('click', '.pick_design_sizeguide', function(){
        $(".popup_sizeguide_section").addClass("active");
    });

    // $('body').on('click', '.custom_accordion_btn', function(){
    //     $(".custom_accordion_btn").each(function(){
    //       $(this).attr("aria-expanded", "false");
    //       $(this).siblings('collapsible-content').removeAttr("open");
    //       $(this).siblings('collapsible-content').css("overflow", "hidden");
    //     })
    //     $(this).attr("aria-expanded", "true");
    //     $(this).siblings('collapsible-content').attr("open", "");
    //     $(this).siblings('collapsible-content').css("overflow", "visible");
    // });

    $('body').on('click', '.custom_accordion_btn[data-block-title="formen-langen"], .custom_accordion_btn[data-block-title="passende-formen-langen"]', function(){
        setTimeout(() => {
          if ($(this).attr('aria-expanded') == 'true') {
            $(".popup_sizeguide_section").addClass("active");
            $(".popup_sizeguide_v1_section").addClass("active");
          }
        }, 200);
    });  
    $(".close-icon-popup, .choose_style_btn, .drawer__overlay").click(function () {
        $('.custom_accordion_btn[data-block-title="formen-langen"], .custom_accordion_btn[data-block-title="passende-formen-langen"]').attr('aria-expanded', 'false');
        $(".popup_sizeguide_section").removeClass("active");
        $(".popup_sizeguide_v1_section").removeClass("active");
    });

  
  $('body').on('click', '.custom_accordion_btn_v2[data-block-title="formen-langen"], .custom_accordion_btn_v2[data-block-title="passende-formen-langen"]', function(){
        setTimeout(() => {
          if ($(this).attr('aria-expanded') == 'true') {
            $(".popup_sizeguide_v1_section").addClass("active");
          }
        }, 200);
    });

  $(".close-icon-popup, .choose_style_btn, .drawer__overlay").click(function () {
        $('.custom_accordion_btn_v2[data-block-title="formen-langen"], .custom_accordion_btn_v2[data-block-title="passende-formen-langen"]').attr('aria-expanded', 'false');
        $(".popup_sizeguide_v1_section").removeClass("active");
    });



// Size guide v1

    $(".pick_design_sizeguide_v1").click(function () {
        $(".popup_sizeguide_v1_section").addClass("active");
    });

  // Size guide tab
    $(".shape_category").click(function(){
        var name = $(this).attr("data-name");
        $(".shape_category, .point_shapelenght_inner").removeClass("active");
        var matchingElement = $(".point_shapelenght_inner[data-content='" + name + "']");
        if(matchingElement.length) {
            $(this).addClass("active");
            matchingElement.addClass("active");
        }
    });



  // product image gallery
  if ($(window).width() > 900) {
    $(document).on('click', '.product__media-image-wrapper', function(){
      if ($(this).hasClass('zoom')) {
        $('.product__media-image-wrapper').removeClass('zoom');
      } else {
        $('.product__media-image-wrapper').removeClass('zoom');
        $(this).addClass('zoom');
      }
    })
  } else {
    let zoomBusy = false;
    $(document).on('click', '.product__media-image-wrapper img', function () {
      if (zoomBusy) return;
      const productMedia = $(this).closest('product-media.product__media');
      if (!productMedia.length) return;
      const productZoom = productMedia.find('.product__zoom-button[aria-expanded="false"]');
      if (productZoom.length) {
        zoomBusy = true;
        productZoom[0].click();
        setTimeout(() => { zoomBusy = false; }, 0);
      }
    });
  }

$(document).on('click', '.pswp__button[data-action="pswp-close"]', function(){
  setTimeout(() => {
    $(this).closest('.pswp').removeClass(
      'pswp--open pswp--animate_opacity pswp--touch pswp--css_animation pswp--svg pswp--visible pswp--animated-in'
    );
    $('product-image-zoom').removeAttr('open style').attr('aria-hidden', 'true');
  }, 500);
});



  $(document).on('click', '.block-swatch__item', function(){
    setTimeout(() => {
      if ($(window).width() > 900) {
        var carouselHeight = $('flickity-carousel.product__media-list.zoom_effect').height();
        // $('flickity-controls .product__thumbnail-list').height(carouselHeight-80);
      } else {
        // $('flickity-controls .product__thumbnail-list').css('height', '100%');
    }
    }, 500);
  })

     

// quick view custom code-start
$('body').on('click', '[is="quick-button"]', function(e){
  e.preventDefault();
  openQuickModal();
  const quickBtn = $(this);
  const dataControl = $(this).attr('aria-controls');
  const quick_view_model = $('#quick_view_model');
  if (!quick_view_model) return;

  $.ajax({
        url: `/products/${dataControl}?view=quick-view`,
        type: "GET",
        dataType: 'html',
        success: function(responseHTML) {
          const rerenderHtml = $(responseHTML).find('product-quick').html();
          quick_view_model.find("product-quick").attr('data-handle', dataControl);
          quick_view_model.find("product-quick").html(rerenderHtml);

          if (quickBtn && quickBtn.hasClass('pdp_upsell_product')) {
            const pdp_upsell = quick_view_model.find("product-quick input[name='properties[_pdp_cross_selling_product]']");
            if (pdp_upsell.length) {
              pdp_upsell.val("true");
              pdp_upsell.removeAttr("disabled");
            }
          } 
          if (quickBtn && quickBtn.hasClass('cart_upsell_product')) {
            const pdp_upsell = quick_view_model.find("product-quick input[name='properties[_cart_cross_selling_product]']");
            if (pdp_upsell.length) {
              pdp_upsell.val("true");
              pdp_upsell.removeAttr("disabled");
            }
          }
          if (quickBtn && quickBtn.hasClass('pdp_empty_cart_product')) {
            const pdp_upsell = quick_view_model.find("product-quick input[name='properties[_empty_cart_trending]']");
            if (pdp_upsell.length) {
              pdp_upsell.val("true");
              pdp_upsell.removeAttr("disabled");
            }
          }
        },
        error: function(xhr, status, error) {
          console.error("Error:", error);
        }
    });
});

$('body').on('change', '#quick_view_model form.shopify-product-form [name="id"]', function(){
  const variantID = $(this).val();
  const quick_view_model = $('#quick_view_model');
  const productQuick = $(this).closest("product-quick");
  const dataHandle = productQuick.attr('data-handle');
  const upsell_product = productQuick.find('[name="properties[_pdp_cross_selling_product]"]');
  let upsell_product_found = false;
  if (upsell_product && upsell_product.length && upsell_product.val() == "true") {
    upsell_product_found = true;
  }

  const cart_upsell_product = productQuick.find('[name="properties[_cart_cross_selling_product]"]');
  let cart_upsell_product_found = false;
  if (cart_upsell_product && cart_upsell_product.length && cart_upsell_product.val() == "true") {
    cart_upsell_product_found = true;
  }

  const empty_upsell_product = productQuick.find('[name="properties[_empty_cart_trending]"]');
  let empty_upsell_product_found = false;
  if (empty_upsell_product && empty_upsell_product.length && empty_upsell_product.val() == "true") {
    empty_upsell_product_found = true;
  }

  $.ajax({
      url: `/products/${dataHandle}?variant=${variantID}&view=quick-view`,
      type: "GET",
      dataType: 'html',
      success: function(responseHTML) {
          const rerenderHtml = $(responseHTML).find('product-quick').html();
          quick_view_model.find("product-quick").attr('data-handle', dataHandle);
          quick_view_model.find("product-quick").html(rerenderHtml);
          if (upsell_product_found) {
            const pdp_upsell = quick_view_model.find("product-quick input[name='properties[_pdp_cross_selling_product]']");
            if (pdp_upsell.length) {
              pdp_upsell.val("true");
              pdp_upsell.removeAttr("disabled");
            }
          }
          if (cart_upsell_product_found) {
            const pdp_upsell = quick_view_model.find("product-quick input[name='properties[_cart_cross_selling_product]']");
            if (pdp_upsell.length) {
              pdp_upsell.val("true");
              pdp_upsell.removeAttr("disabled");
            }
          }
          if (empty_upsell_product) {
            const pdp_upsell = quick_view_model.find("product-quick input[name='properties[_empty_cart_trending]']");
            if (pdp_upsell.length) {
              pdp_upsell.val("true");
              pdp_upsell.removeAttr("disabled");
            }
          }
          openQuickModal();
      },
      error: function(xhr, status, error) {
          console.error("Error:", error);
      },
  });
}) 

$('body').on('click', '.quick_view_model_close, .quick_view_model_overlay, .mobile_bar_close', function(){
  closeQuickModal();
}) 

$('body').on('click', 'button#AddToCart[data-product-add-to-cart-button]', function(){
  setTimeout(() => {
    closeQuickModal();
  }, 500);
}) 

function openQuickModal() {
  $('#quick_view_model').addClass("is-open");
  document.body.style.overflow = "hidden";
}

function closeQuickModal() {
  $('#quick_view_model').removeClass("is-open");
  document.body.style.overflow = "";
}

window.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && $('#quick_view_model').hasClass("is-open")) {
    closeQuickModal();
  }
});

// quick view custom code-end


// all in one product black week special

// if ($('[data-color-collection-url]').length > 0) {
//   const colURL = $('[data-color-collection-url]').val();
//   let totalProCounter = 250;
//   let colTotalProduct = $('[data-color-collection-url]').attr('data-total-product');
//   if (colURL && colTotalProduct && parseInt(colTotalProduct) > 250) {
//      colTotalProduct = parseInt(colTotalProduct) - 250;
//      let calTotal = colTotalProduct / 250;
//      const calTotalCeil = Math.ceil(calTotal);
//     //  for (let index = 1; index <= calTotalCeil; index++) {

//         $.ajax({
//           url: `${colURL}?page=2&view=color-chooser-filter-api-2025`,
//           type: 'GET',
//           dataType: 'html',
//           success: function(responseHTML){                
//             $('color-choose-drawer .products-tiles').append($(responseHTML).html());               
//           }          
//         })
//     //  }
//   }
// }
// const colorCollectionInput = document.querySelector('[data-color-collection-url]');

// if (colorCollectionInput) {
//   const colURL = colorCollectionInput.value;
//   let totalProCounter = 250;
//   let colTotalProduct = colorCollectionInput.getAttribute('data-total-product');

//   if (colURL && colTotalProduct && parseInt(colTotalProduct) > 250) {
//     colTotalProduct = parseInt(colTotalProduct) - 250;
//     const calTotalCeil = Math.ceil(colTotalProduct / 250);

//     // AJAX request using fetch()
//     fetch(`/collections/all-in-one-set?page=2&view=color-chooser-filter-api-2025`)
//       .then(response => response.text())
//       .then(responseHTML => {
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(responseHTML, 'text/html');

//         const productsHtml = doc.querySelector('.products-tiles').innerHTML; // Similar to $(responseHTML).html()

//         const targetContainer = document.querySelector('color-choose-drawer .products-tiles');
//         if (targetContainer) {
//           targetContainer.insertAdjacentHTML('beforeend', productsHtml);
//         }
//       })
//       .catch(error => console.error('Fetch error:', error));
//   }
// }

$('.all_in_one_slider .collection__top_item').on('click', function () {

  $(".search-area").slideUp();
  $(".search-area input").val('');
  $(".option-popup .popup-inner .tags.po-form").slideUp();
  $(".headline-icons .manikure_pedikure_filter").slideUp();
  $(".headline-icons .all_in_one_filter").removeClass('active_filter');
  $(".product-item__label-list .label.label--custom.label--custom-not-vender").show();
  $(".product-item__label-list .label.label--custom.vendor").hide();
  $(".product-item__label-list .label.label--custom.manikure_pedikure").hide();
  $(".filters-pop-new").addClass('disabled');

  if ($(this).hasClass('active')) {
    console.log($(this));
    $('.collection__top_item[data-filter="alle"]').click();
    return;
  }

  const dataFilter = $(this).attr('data-filter');
  $('.all_in_one_slider .collection__top_item').removeClass('active');
  $(this).addClass('active');
  $('.all_in_one_slider .product-tile-item').removeAttr('style');
  $('.all_in_one_slider .product-tile-item').removeAttr('hidden');

  if (dataFilter != 'alle') {
    $('.all_in_one_slider .product-tile-item').each(function () {
      if ($(this).attr('data-category').includes(dataFilter)) {
        $(this).removeAttr('hidden');
      } else {
        $(this).attr('hidden', true);
      }
    });
  }

  if (dataFilter == 'press_ons') {
    // $(".filters-pop-new").removeClass('disabled');
    $(".option-popup .popup-inner .tags.po-form").slideToggle();
    $(".headline-icons .manikure_pedikure_filter").hide();
    $(".product-item__label-list .label.label--custom.label--custom-not-vender").slideToggle();
    $(".product-item__label-list .label.label--custom.vendor").slideToggle();
    $(".product-item__label-list .label.label--custom.manikure_pedikure").hide();
  }
  if (dataFilter == 'gel_strips') {
    $(".filters-pop-new").removeClass('disabled');
    $(".option-popup .popup-inner .tags.po-form").hide();
    $(".headline-icons .manikure_pedikure_filter").slideToggle();
    $(".product-item__label-list .label.label--custom.label--custom-not-vender").slideToggle();
    $(".product-item__label-list .label.label--custom.vendor").hide();
    $(".product-item__label-list .label.label--custom.manikure_pedikure").slideToggle();
  }

})

// $("a.filters-pop-new").click(function(e) {
//     e.preventDefault();
//     if ($('.all_in_one_slider .collection__top_item.active').attr('data-filter') == 'press_ons') {
//       $(".option-popup .popup-inner .tags.po-form").slideToggle();
//       $(".headline-icons .manikure_pedikure_filter").hide();
//       $(".product-item__label-list .label.label--custom.label--custom-not-vender").slideToggle();
//       $(".product-item__label-list .label.label--custom.vendor").slideToggle();
//       $(".product-item__label-list .label.label--custom.manikure_pedikure").hide();
//     } else if ($('.all_in_one_slider .collection__top_item.active').attr('data-filter') == 'gel_strips') {
//       $(".option-popup .popup-inner .tags.po-form").hide();
//       $(".headline-icons .manikure_pedikure_filter").slideToggle();
//       $(".product-item__label-list .label.label--custom.label--custom-not-vender").slideToggle();
//       $(".product-item__label-list .label.label--custom.vendor").hide();
//       $(".product-item__label-list .label.label--custom.manikure_pedikure").slideToggle();

//     }
//     $(".search-area").slideUp();
// });



  $('body').on('click', '.additional_product_tab_item', function(){
    const $parent = $(this).closest('.additional_product_row');
    const tabKey = $(this).attr('data-tab');
    $parent.find('.additional_product_content').removeClass('active_tab');
    $parent.find('.additional_product_tab_item').removeClass('active_tab');
    $(this).addClass('active_tab');
    $parent.find(`.additional_product_content[data-tab="${tabKey}"]`).addClass('active_tab');
  }) 

  $('body').on('click', '.additional_bundle_label', function(){
    const $parent = $(this).closest('.additional_product_row');
    $parent.find('.additional_product_option').toggleClass('active');
  });

  function updateTotalPrice($parent) {
    var total = 0;
    var $checkboxes = $parent.find(".bundle_content");
    var $priceTargets = $parent.find(".additional_price, .ap_button_price");
    var $addToCartButton = $parent.find(".ap_button");

    $checkboxes.each(function () {
      var $cb = $(this);
      if ($cb.is(":checked")) {
        var $label = $cb.closest(".bundle_content_label");
        if (!$label.length) return;

        var priceStr = $label.data("price");
        if (!priceStr) return;

        var price = parseFloat(String(priceStr).replace(",", "."));
        if (!isFinite(price)) return;

        total += price;
      }
    });

    var formatted = "€" + total.toFixed(2).replace(".", ",");

    $priceTargets.each(function () {
      $(this).text(formatted);
    });

    if ($addToCartButton.length) {
      var shouldDisable = total === 0;
      $addToCartButton
        .prop("disabled", shouldDisable)
        .toggleClass("is-disabled", shouldDisable);
    }
  }

  // Initial calculation
  updateTotalPrice($('.additional_product_row'));

  $('body').on('change', '.bundle_content', function(){
    const $parent = $(this).closest('.additional_product_row');
    updateTotalPrice($parent);
  })

  $('body').on('click', '#AddToCartAccBundle', async function(){
    var $addToCartButton = $(this);
    const $that = this;
    $addToCartButton.prop("disabled", true).addClass("is-disabled");
    const $parent = $(this).closest('.additional_product_row');
    var product_data = [];
    $parent.find('input.bundle_content:checked').each(function() {
        product_data.push(
          { 
            quantity: 1, 
            id: parseInt($(this).val()) 
          }
        );
    });

    if (product_data.length > 0) {
      try {
            if (window.DnAtcSource) window.DnAtcSource.stamp(product_data, null, window.DnAtcSource.templateLabel('add from additional products bundle'));
            const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                body: JSON.stringify({ items: product_data }),
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                },
                method: 'POST'
            });

            const responseJson = await response.json();

            if (!response.ok) {
                throw new Error(responseJson["description"] || "Error adding items to cart");
            }

            fetch('/?section_id=mini-cart').then(res => res.text()).then(data => {
                    const html = document.createElement("div");
                    html.innerHTML = data;
                    const newbox = html.querySelector("#mini-cart").innerHTML;
                    document.querySelector('#mini-cart').innerHTML = newbox;
                })

                let cartEndPoint = window.themeVariables.routes.cartUrl || '/cart';
                fetch(`${cartEndPoint}.js`).then(async (response2) => {
                    const cartContent = await response2.json();
                    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                        bubbles: true,
                        detail: {
                            cart: cartContent
                        }
                    }));

                    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                        bubbles: true,
                        detail: {
                            cart: cartContent,
                            openMiniCart: window.themeVariables.settings.cartType === "drawer" && $that.closest(".drawer") === null
                        }
                    }));

                });
              const cartUpdateEvent = new Event('cartUpdate');
              window.dispatchEvent(cartUpdateEvent);
              $addToCartButton.prop("disabled", false).removeClass("is-disabled");

              $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: "success",
                    error: ""
                }
            }));
          
        } catch (error) {
            $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: "error",
                    error: error.message
                }
            }));
            $addToCartButton.prop("disabled", false).removeClass("is-disabled");
        }
    }

  })

  $('body').on('click', '#AddToCartSubPro', async function(){
    var $addToCartButton = $(this);
    const $that = this;
    
    const $form = $addToCartButton.closest('form');
    if (!$form.length) return;

    const productVariantId = $form.find('[name="id"]').val();
    if (!productVariantId) return;
    $addToCartButton.prop("disabled", true).attr("aria-busy", "true").addClass("is-disabled");
    const formData = new FormData($form[0]);
    if (window.DnAtcSource && !formData.has('properties[_shopify_source]')) formData.set('properties[_shopify_source]', window.DnAtcSource.value($form[0], window.DnAtcSource.templateLabel('add from subscription product form')));

      try {
          let cartEndPoint = window.themeVariables.routes.cartUrl || '/cart';
          const cart = await fetch(`${cartEndPoint}.js`).then(res => res.json());
          const existingItem = cart.items.find(
            item => item.variant_id == productVariantId
          );

          if (!existingItem) {
              const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                body: formData,
                method: "POST",
                headers: {
                  "X-Requested-With": "XMLHttpRequest"
                }
              });

            const responseJson = await response.json();

            if (!response.ok) {
                throw new Error(responseJson["description"] || "Error adding items to cart");
            }
          }

            fetch('/?section_id=mini-cart').then(res => res.text()).then(data => {
                    const html = document.createElement("div");
                    html.innerHTML = data;
                    const newbox = html.querySelector("#mini-cart").innerHTML;
                    document.querySelector('#mini-cart').innerHTML = newbox;
                })

                fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
                    const cartContent = await response2.json();
                    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                        bubbles: true,
                        detail: {
                            cart: cartContent
                        }
                    }));

                    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                        bubbles: true,
                        detail: {
                            cart: cartContent,
                            openMiniCart: window.themeVariables.settings.cartType === "drawer" && $that.closest(".drawer") === null
                        }
                    }));

                });
              const cartUpdateEvent = new Event('cartUpdate');
              window.dispatchEvent(cartUpdateEvent);
              $addToCartButton.prop("disabled", false).removeAttr("aria-busy").removeClass("is-disabled");

              $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: "success",
                    error: ""
                }
            }));
          
        } catch (error) {
            $that.dispatchEvent(new CustomEvent("cart-notification:show", {
                bubbles: true,
                cancelable: true,
                detail: {
                    status: "error",
                    error: error.message
                }
            }));
            $addToCartButton.prop("disabled", false).removeAttr("aria-busy").removeClass("is-disabled");
        }

  })


  
  // $('body').on('click', '#AddToCartColorRefill', function(){
  //   let varId = $(this).attr('data-variant');
  //   let productlink = $(this).attr('data-product');
  //   window.location.href = `/products/${productlink}?free_ids=${varId}`;
  // })

  


     // valentines-sale discount code
// $('body').on('click', '.copy_discount_code', function(){
//       var copyText = $(this).attr("data-copy");
//       if (!copyText || !navigator.clipboard) return;
//       const $btn = $(this);
//       navigator.clipboard.writeText(copyText).then(async function () {
//         $btn.addClass("show-tooltip");

//       try {
//             if (copyText) {
//                 localStorage.setItem('storedDiscount', copyText);
//                 const response =  await fetch(`/discount/${copyText}`);
//                 const responseText = await response.text();
//                 var parser = new DOMParser();
//                 var htmlDoc = parser.parseFromString(responseText, "text/html");
//                 // console.log("Discount HTML document:", htmlDoc);
//                 if (response.status == 200) {
//                   document.body.classList.add('love_discount_code_applied');
//                   var discount = readCookie('discount_code');
//                   if (discount && discount == copyText) {
//                     document.getElementById("discount-banner-text").innerHTML = "<span>Super! Dein Rabattcode <b>" + discount + "</b>  wurde zum Warenkorb hinzugefügt.</span>";
//                       console.log("banner_storage");
//                       $("#discount-banner").css("display", "flex");
//                       sessionStorage.setItem("banner-session", 1);
//                   } else {
//                     console.log("code_not_defined")
//                     $("#discount-banner").css("display", "none");
//                   }

//                   fetch('/?section_id=mini-cart').then(res => res.text()).then(data => {
//                       const html = document.createElement("div");
//                       html.innerHTML = data;
//                       const newbox = html.querySelector("#mini-cart").innerHTML;
//                       document.querySelector('#mini-cart').innerHTML = newbox;
//                   })

//                 }
//             }

//         } catch(error) {
//             console.error(`Error: ${error.message}`)
//         }

//         setTimeout(function () {
//           $btn.removeClass("show-tooltip");
//         }, 1500);
//       });
//   });

// function readCookie(name) {
//   var nameEQ = name + "=";
//   var ca = document.cookie.split(';');
//   for (var i = 0; i < ca.length; i++) {
//     var c = ca[i];
//     while (c.charAt(0) == ' ') 
//       c = c.substring(1, c.length);
//     if (c.indexOf(nameEQ) == 0) 
//       return c.substring(nameEQ.length, c.length);
//   }
//   return null;
// };
  
  // klaviyo collection
$('body').on('click', '.view_pdp_btn.klaviyo-bis-card-trigger', function(){
  const link = $(this).attr("data-product-url");
  sessionStorage.setItem('klaviyoBackToStock', '1');
  window.location.href = link;
});

if ($('body').is('[data-template]')) {
    const templateName = $('body').attr('data-template');
    if (templateName == "product" && dnSpeicherLesen('sessionStorage', 'klaviyoBackToStock') !== null) {
      try { sessionStorage.removeItem('klaviyoBackToStock'); } catch (dnFehler) {}
      if ($('button#AddToCart').is('[disabled]')) {
          var klaviyoBtnInterval = setInterval(function () {
          var $btn = $('form.shopify-product-form #klaviyo-bis-button-container button');

          if ($btn.length) {
            clearInterval(klaviyoBtnInterval);
            $btn.trigger('click');
          }
        }, 500);

        setTimeout(function () {
          clearInterval(klaviyoBtnInterval);
        }, 30000);
      }
    }
}

// klaviyo collection end here


  $(document).on('click', '.code_discount_bar_copy', function () {
    var $btn = $(this);
    var code = $.trim($btn.data('code'));
    if (!code) return;

    function feedback() {
      if ($btn.data('busy')) return;
      var original = $btn.html();

      $btn.width($btn.width());          // lock current width
      $btn.data('busy', true).html('✔').addClass('is-copied');

      setTimeout(function () {
        $btn.html(original)
            .removeClass('is-copied')
            .data('busy', false)
            .css('width', '');           // release
      }, 1500);
    }

    function fallback() {
      var $ta = $(document.createElement('textarea'))
        .attr('readonly', '')
        .val(code)
        .css({ position: 'absolute', left: '-9999px' })
        .appendTo('body');
      $ta[0].select();
      try { document.execCommand('copy'); feedback(); } catch (err) { console.error(err); }
      $ta.remove();
    }

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(feedback).catch(fallback);
    } else {
      fallback();
    }
  });
  

}); // ready function end

// mobile device base link
 (function () {
  if (!document || !document.querySelectorAll) return;
  const buttons = document.querySelectorAll(".app_widget_btn_link");
  if (!buttons.length) return;
  buttons.forEach(function (btn) {
    if (!btn || !btn.addEventListener) return;

    btn.addEventListener("click", function (e) {
      try {
        e.preventDefault();
        const copyText = btn.getAttribute("data-copy") || "";
        const androidLink = btn.getAttribute("data-android") || "";
        const iosLink = btn.getAttribute("data-ios") || "";
        const webLink = btn.getAttribute("data-web") || "";
        const userAgent =
          (typeof navigator !== "undefined" &&
            (navigator.userAgent || navigator.vendor)) ||
          "";

        const redirect = () => {
          if (/android/i.test(userAgent) && androidLink) {
            window.location.href = androidLink;
          } else if (
            /iPad|iPhone|iPod/.test(userAgent) &&
            !window.MSStream &&
            iosLink
          ) {
            window.location.href = iosLink;
          } else if (webLink) {
            window.location.href = webLink;
          }
        };

        if (
          copyText &&
          navigator &&
          navigator.clipboard &&
          navigator.clipboard.writeText
        ) {
          navigator.clipboard
            .writeText(copyText)
            .then(() => {
              const originalText = btn.innerText || "";
              btn.innerText = "Code kopiert!";
              setTimeout(() => {
                btn.innerText = originalText;
                redirect();
              }, 1200);
            })
            .catch(() => {
              redirect();
            });
        } else {
          redirect();
        }
      } catch (err) {
        console.error("Button handler error:", err);
      }
    });
  });
})();



// faq tab js
 const accordionContent = document.querySelectorAll('.accordion-contnt');

  accordionContent.forEach((item, i) => {
    item.querySelector('.accordion_header').addEventListener('click', () => {
      const isOpen = item.classList.toggle('open');
      const knopf = item.querySelector('.faq_toggle, .dn-faq-frage');
      if (knopf) knopf.setAttribute('aria-expanded', isOpen);
      const desc = item.querySelector('.description_ac');
      const [plus, minus] = [item.querySelector('.plus_icon'), item.querySelector('.minus_icon')];

      desc.style.height = isOpen ? `${desc.scrollHeight}px` : '0px';
      plus.style.display = isOpen ? 'none' : 'inline-block';
      minus.style.display = isOpen ? 'inline-block' : 'none';

      accordionContent.forEach((other, j) => {
        if (i !== j) {
          other.classList.remove('open');
          const andererKnopf = other.querySelector('.faq_toggle, .dn-faq-frage');
          if (andererKnopf) andererKnopf.setAttribute('aria-expanded', 'false');
          const otherDesc = other.querySelector('.description_ac');
          const [otherPlus, otherMinus] = [other.querySelector('.plus_icon'), other.querySelector('.minus_icon')];
          otherDesc.style.height = '0px';
          otherPlus.style.display = 'inline-block';
          otherMinus.style.display = 'none';
        }
      });
    });
  });

if (window.location.href.includes("black-week-special-set")) {

  const isIphone = /iPhone|iPod/i.test(navigator.userAgent);

  fetch(`/collections/all-in-one-set?page=2&view=color-chooser-filter-api-2025`)
    .then(response => response.text())
    .then(responseHTML => {

      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, 'text/html');

      const incomingTiles = doc.querySelector('.products-tiles');
      const targetContainer = document.querySelector('color-choose-drawer .products-tiles');

      if (!incomingTiles || !targetContainer) return;

      const children = Array.from(incomingTiles.children);
      const half = Math.ceil(children.length / 2);

      // Create wrapper divs for safe insert
      const firstWrapper = document.createElement('div');
      const secondWrapper = document.createElement('div');

      // Slice into 2 big HTML chunks
      for (let i = 0; i < half; i++) {
        firstWrapper.appendChild(children[i].cloneNode(true));
      }

      for (let i = half; i < children.length; i++) {
        secondWrapper.appendChild(children[i].cloneNode(true));
      }

      // ---------- iPHONE SAFE MODE ----------
      if (isIphone) {
        // Insert first half in ONE go
        targetContainer.insertAdjacentHTML('beforeend', firstWrapper.innerHTML);

        // Insert second half after 0.2 sec, also ONE go
        setTimeout(() => {
          targetContainer.insertAdjacentHTML('beforeend', secondWrapper.innerHTML);
        }, 500);
      }

      // ---------- NORMAL DEVICES ----------
      else {
        targetContainer.insertAdjacentHTML('beforeend', incomingTiles.innerHTML);
      }

    })
    .catch(error => console.error('Fetch error:', error));
}


// sale page load more
document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".image_with_product_section");
  if (!sections.length) return;
  sections.forEach((section) => {
    const productsWrapper = section.querySelector(".load_product");
    const items = section.querySelectorAll(".load_product .new_product_item");
    const loadMoreBtn = section.querySelector(".loadMoreProduct");
    if (!productsWrapper || !items.length || !loadMoreBtn) {
      if (loadMoreBtn) loadMoreBtn.style.display = "none";
      return;
    }
    const isMobile = window.innerWidth <= 768;
    const initialCount = isMobile ? 6 : 8;
    const increment = 4;
    let visibleCount = initialCount;
    items.forEach((item, index) => {
      item.style.display = index < initialCount ? "flex" : "none";
    });

    loadMoreBtn.style.display = items.length > initialCount ? "block" : "none";
    loadMoreBtn.addEventListener("click", function () {
      visibleCount += increment;
      items.forEach((item, index) => {
        if (index < visibleCount) {
          item.style.display = "flex";
        }
      });

      if (visibleCount >= items.length) {
        loadMoreBtn.style.display = "none";
      }
    });
  });

});

// slider for sale week section:image with product
document.addEventListener("DOMContentLoaded", () => {
  const iwpDesktopMedia = window.matchMedia("(min-width: 769px)");

  function iwpEqualHeights() {
    const iwpItems = document.querySelectorAll(".iwp-product-slider .product-item-meta");
    if (!iwpItems.length) return;

    // Reset first
    iwpItems.forEach((iwpEl) => {
      iwpEl.style.minHeight = "0px";
      iwpEl.style.height = "auto";
    });

    // Wait for browser layout update
    requestAnimationFrame(() => {
      let iwpMaxHeight = 0;

      iwpItems.forEach((iwpEl) => {
        const iwpHeight = iwpEl.getBoundingClientRect().height;
        if (iwpHeight > iwpMaxHeight) {
          iwpMaxHeight = iwpHeight;
        }
      });

      iwpItems.forEach((iwpEl) => {
        iwpEl.style.minHeight = Math.ceil(iwpMaxHeight) + "px";
      });
    });
  }

  function iwpRunEqualHeightAfterLayout() {
    setTimeout(iwpEqualHeights, 100);
    setTimeout(iwpEqualHeights, 300);
    setTimeout(iwpEqualHeights, 700);
  }

  if (!iwpDesktopMedia.matches) return;

  document.querySelectorAll(".iwp-product-slider .product__media-list").forEach((iwpEl) => {
    const iwpMediaFlkty = new Flickity(iwpEl, {
      pageDots: true,
      cellAlign: "left",
      contain: true,
      wrapAround: false,
      prevNextButtons: false,
      draggable: false,
      fade: true,
    });

    iwpMediaFlkty.on("ready", iwpRunEqualHeightAfterLayout);
    iwpMediaFlkty.on("settle", iwpRunEqualHeightAfterLayout);
  });

  setTimeout(() => {
    document.querySelectorAll(".iwp-product-slider").forEach((iwpEl) => {
      const iwpOldFlkty = Flickity.data(iwpEl);
      if (iwpOldFlkty) {
        iwpOldFlkty.destroy();
      }

      const iwpMainFlkty = new Flickity(iwpEl, {
        pageDots: false,
        fade: false,
        cellAlign: "left",
        contain: true,
        rightToLeft: false,
        wrapAround: false,
        prevNextButtons: true,
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 60,
          y2: 45,
          x3: 15,
        },
      });

      iwpMainFlkty.on("ready", iwpRunEqualHeightAfterLayout);
      iwpMainFlkty.on("settle", iwpRunEqualHeightAfterLayout);
    });

    iwpRunEqualHeightAfterLayout();
  }, 200);

  window.addEventListener("load", iwpRunEqualHeightAfterLayout);

  let iwpResizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(iwpResizeTimer);

    iwpResizeTimer = setTimeout(() => {
      if (iwpDesktopMedia.matches) {
        iwpRunEqualHeightAfterLayout();
      } else {
        document.querySelectorAll(".iwp-product-slider .product-item-meta").forEach((iwpEl) => {
          iwpEl.style.minHeight = "";
          iwpEl.style.height = "";
        });
      }
    }, 200);
  });
});


  // set minHeight with js IWP section
// function iwpSetEqualHeights() {
//   const iwpItems = document.querySelectorAll('.iwp-product-slider .product-item-meta');
//   if (!iwpItems.length) return;

//   iwpItems.forEach(iwpItem => iwpItem.style.minHeight = '');

//   let iwpMaxHeight = 0;

//   iwpItems.forEach(iwpItem => {
//     const iwpItemHeight = iwpItem.offsetHeight;
//     if (iwpItemHeight > iwpMaxHeight) {
//       iwpMaxHeight = iwpItemHeight;
//     }
//   });

//   iwpItems.forEach(iwpItem => {
//     iwpItem.style.minHeight = iwpMaxHeight + 'px';
//   });
// }

// window.addEventListener('load', iwpSetEqualHeights);
// window.addEventListener('resize', iwpSetEqualHeights);

// document.querySelectorAll('.tpc-tab').forEach(iwpTab => {
//   iwpTab.addEventListener('click', () => {
//     setTimeout(iwpSetEqualHeights, 150);
//   });
// });


// product description warning button
document.querySelectorAll('.custom_accordion_btn[data-block-title="inhaltsstoffe"]').forEach(btn => {
  const wrapper = btn.closest('.product-tabs__tab-item-wrapper');
  if (!wrapper) return;

  const warningMessage = wrapper.querySelector('.warning_message');
  
  // Exit early if warningMessage doesn't exist
  if (!warningMessage) return;

  const productMeta = wrapper.querySelector('.product_content_meta');
  const warningButton = wrapper.querySelector('.warning_button');

  btn.addEventListener('click', () => {
    setTimeout(() => {
      warningMessage.style.display = '';
      if (productMeta) productMeta.style.display = 'none';
    }, 500);
  });

  if (warningButton) {
    warningButton.addEventListener('click', () => {
      warningMessage.style.display = 'none';
      if (productMeta) productMeta.style.display = '';
    });
  }

  if (productMeta) {
    productMeta.style.display = 'none';
  }
});




setTimeout(() => {
  $('product-item').each(function(){
    let reviewCount = $(this).find('.jdgm-prev-badge').attr('data-average-rating');
    let reviewCountInt = parseFloat(reviewCount)
    if (reviewCount && reviewCountInt > 4) {
      $(this).find('.face_lift_review_mb').text(`${String(reviewCount).replace(/\.00/g, "")} ★`);
    }
  })
}, 1000);

(function () {
  if (typeof window.jQuery !== 'function') return; // ohne jQuery kein Badge-Umbau (Sentry DE-1BE)
  const MIN_RATING = 4;
  let scheduled = false;
  const fmt = (n) => String(parseFloat(n.toFixed(2)));

  function enhance() {
    /* Sentry DOONAILS-DE-213 (2026-10-13): ohne geladenes jQuery liegt auf $ nur der Ready-Platzhalter aus theme.liquid. */
    const $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.jquery) return;
    $('.review_info_block .jdgm-prev-badge').each(function () {
      const $badge = $(this);
      const $badgeParent = $(this).closest('.review_info--judgeme-review');
      const rating = parseFloat($badge.attr('data-average-rating'));
      const count = $badge.attr('data-number-of-reviews');
      const $text = $badgeParent.find('.judgeme_widget_new_text');
      if (!$text.length || !rating || rating <= MIN_RATING) return;

      const html = `${fmt(rating)} (${count} Bewertungen)`;
      if ($text.html() === html) return;
      $text.html(html);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; enhance(); });
  }

  $(schedule);

  // Nur planen, wenn es ueberhaupt Badge-Bloecke gibt (2026-09-29, PageSpeed): der Beobachter feuert bei jeder DOM-Aenderung
  // der Seite (Slider, Apps), enhance() fand ohne .review_info_block nie etwas. Die Live-Liste kostet pro Aufruf nichts.
  const dnBadgeBloecke = document.getElementsByClassName('review_info_block');
  new MutationObserver(function () { if (dnBadgeBloecke.length) schedule(); }).observe(document.body || document.documentElement, { // body war in In-App-Browsern noch null (Sentry DE-1VJ)
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-average-rating', 'data-number-of-reviews']
  });

})();